import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import AboutModal from '../../AboutModal';

export default function About({
  show,
  onHide,
}: {
  show: boolean,
  onHide: () => void,
}) {
  return (
    <AboutModal show={show} onHide={onHide}>
      <Row className="align-items-stretch">
        <Col md={6}>
          <Card className="h-100 water-balance-culture-instruction-card">
            <Card.Header className="shadow-sm">
              SOBRE
            </Card.Header>
            <Card.Body>
              Sobre índice por área
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="h-100 water-balance-culture-instruction-card">
            <Card.Header className="shadow-sm">
              INSTRUÇÕES PARA CONSULTA
            </Card.Header>
            <Card.Body>
              Instruções índice por área
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </AboutModal>
  );
}
